export function getDefaultRouteForMissionStatus(missionStatus) {
    switch (missionStatus) {
        case 'closed':
        case 'complete':
            return 'pastshifts';
        default:
            return 'upcomingshifts';
    }
}
